import { green, grey, red, yellow } from "@material-ui/core/colors";

const colors = {
  primary: {
    dark: "#538855",
    main: "#74BD76",
    light: "#85da88",
  },
  background: {
    light: grey[200],
  },
  menu: {
    text: grey[400],
    icon: grey[300],
  },
  success: {
    main: green[400],
  },
  error: {
    main: red[400],
  },
  info: {
    main: yellow[400],
  },
  text: {
    light: grey[200],
    main: grey[500],
    dark: grey[600],
  },
};

export default colors;
